import { render, staticRenderFns } from "./AppointmentsReport.vue?vue&type=template&id=fb2fbb6c&"
import script from "./AppointmentsReport.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports